import React, { useEffect, useState } from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import { useSelector } from "react-redux";
import CustomDropdownMultiple from "../../components/Forms/CustomInputs/CustomDropdownMultiple";

const AddUpdateUI = ({ formik, relationData }) => {
  const { data: categories } = useSelector((state) => state.category);
  const { values, errors, handleChange, handleBlur, setFieldValue } = formik;
  const [selectedCategory, setSelectedCategory] = useState([]);
  useEffect(() => {
    if (relationData && Object.keys(relationData).length > 0) {
      const categoryArray = Object.values(relationData.category).map((cat) => ({
        label: cat.name,
        value: cat._id,
      }));
      setSelectedCategory(categoryArray);
    }
  }, [relationData]);
  return (
    <>
      <CustomTextbox
        fieldName="name"
        value={values.name}
        error={errors.name}
        label={"Genre Name"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />

      <CustomDropdownMultiple
        fieldName="category"
        values={selectedCategory}
        error={errors.category}
        label={"Select Art Form"}
        classes={"col-md-12"}
        setFieldValue={setFieldValue}
        handleChange={(value) => setSelectedCategory(value)}
        options={
          categories
            ? categories?.map((data) => {
              return { label: data.name, value: data._id };
            })
            : []
        }
      />
    </>
  );
};

export default AddUpdateUI;
